import { CORE_API_URL } from '@/src/shared/config';

// The browser follows this link, so it is the public api URL. Kept apart from
// google.ts, which uses the server-only client.
export function getGoogleAuthUrl(): string {
  return `${CORE_API_URL.replace(/\/$/, '')}/v1/auth/google/login`;
}
